/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-07-28 09:22:39
 * @LastEditors: linxi
 * @LastEditTime: 2021-08-11 09:24:44
 */
import { Request } from "./request";

export interface WarningRulesAnaylseParams {
  dType?: number;
  regionCode?: string;
  scope?: number;
  text?: string;
}

export function getWarningRuleAnaylse(
  params: WarningRulesAnaylseParams
): Request {
  return {
    url: `/api/analysis/caution/rule/usage`,
    method: "GET",
    params,
  };
}
